import {createAsyncThunk} from "@reduxjs/toolkit";
import {ApplicationState} from "store";
import {DragLockMessage} from "types/websocket";
import {sendWebSocketMessage} from "../board";

export const updateNoteDragState = createAsyncThunk<void, {noteId: string; dragging: boolean}, {state: ApplicationState}>(
  "dragLocks/updateNoteDragState",
  async ({noteId, dragging}) => {
    try {
      const message: DragLockMessage = {
        type: "DRAG_LOCK_MESSAGE",
        data: {
          action: dragging ? "ACQUIRE" : "RELEASE",
          noteId,
        },
      };
      sendWebSocketMessage(message);
    } catch (error) {
      // Silently handle errors to avoid disrupting user experience
    }
  }
);

// Convenience thunks for backward compatibility
export const broadcastNoteDragStart = createAsyncThunk<void, string, {state: ApplicationState}>("dragLocks/broadcastNoteDragStart", async (noteId, {dispatch}) => {
  dispatch(updateNoteDragState({noteId, dragging: true}));
});

export const broadcastNoteDragEnd = createAsyncThunk<void, string, {state: ApplicationState}>("dragLocks/broadcastNoteDragEnd", async (noteId, {dispatch}) => {
  dispatch(updateNoteDragState({noteId, dragging: false}));
});
